import {assert} from 'Asserts';
import {PolicyStatement} from 'auth/PolicyConstants';
import {ActionItemType} from 'auth/settings/getActionRowDatas';

import {
  ActorCollaborator,
  DataPolicyActorCollaborator,
  DataPolicyGroupCollaborator,
  GroupCollaborator,
  isDataPolicyActorCollaborator,
  isDataPolicyGroupCollaborator,
  isSchemaPolicyActorCollaborator,
  isSchemaPolicyGroupCollaborator,
  PolicyType,
  SchemaPolicyActorCollaborator,
  SchemaPolicyGroupCollaborator,
} from './PermissionConstants';

// Future/ideal design: use generic User and Group Collaborator interfaces with a single policyId property and
// get rid of these functions
export function getCollaboratorPolicyKey(collaborator: ActorCollaborator): string {
  if (isDataPolicyActorCollaborator(collaborator)) {
    return 'dataPolicyId';
  }
  assert(isSchemaPolicyActorCollaborator(collaborator), 'Unexpected policy type');
  return 'schemaPolicyId';
}

export function getCollaboratorAdminPolicyKey(collaborator: GroupCollaborator): string {
  if (isDataPolicyGroupCollaborator(collaborator)) {
    return 'adminDataPolicyId';
  }
  assert(isSchemaPolicyGroupCollaborator(collaborator), 'Unexpected policy type');
  return 'adminSchemaPolicyId';
}

export function getCollaboratorMemberPolicyKey(collaborator: GroupCollaborator): string {
  if (isDataPolicyGroupCollaborator(collaborator)) {
    return 'memberDataPolicyId';
  }
  return 'memberSchemaPolicyId';
}

export function getCollaboratorPolicyId(collaborator: ActorCollaborator): string | null {
  if (isDataPolicyActorCollaborator(collaborator)) {
    return collaborator.dataPolicyId;
  }
  return collaborator.schemaPolicyId;
}

export function setCollaboratorPolicyId(
  collaborator: Partial<ActorCollaborator>,
  policyType: PolicyType,
  id: string
): void {
  if (policyType === PolicyType.DATA) {
    (collaborator as DataPolicyActorCollaborator).dataPolicyId = id;
  } else {
    (collaborator as SchemaPolicyActorCollaborator).schemaPolicyId = id;
  }
}

export function getCollaboratorMemberPolicyId(collaborator: GroupCollaborator): string | null {
  if (isDataPolicyGroupCollaborator(collaborator)) {
    return collaborator.memberDataPolicyId;
  }
  return collaborator.memberSchemaPolicyId;
}

export function setCollaboratorMemberPolicyId(
  collaborator: Partial<GroupCollaborator>,
  policyType: PolicyType,
  id: string | null
): void {
  if (policyType === PolicyType.DATA) {
    (collaborator as DataPolicyGroupCollaborator).memberDataPolicyId = id;
  } else {
    (collaborator as SchemaPolicyGroupCollaborator).memberSchemaPolicyId = id;
  }
}

export function getCollaboratorAdminPolicyId(collaborator: GroupCollaborator): string | null {
  if (isDataPolicyGroupCollaborator(collaborator)) {
    return collaborator.adminDataPolicyId;
  }
  return collaborator.adminSchemaPolicyId;
}

export function setCollaboratorAdminPolicyId(
  collaborator: Partial<GroupCollaborator>,
  policyType: PolicyType,
  id: string | null
): void {
  if (policyType === PolicyType.DATA) {
    (collaborator as DataPolicyGroupCollaborator).adminDataPolicyId = id;
  } else {
    (collaborator as SchemaPolicyGroupCollaborator).adminSchemaPolicyId = id;
  }
}

export function findMatchingPolicyStatement(
  policyStatements: Array<PolicyStatement>,
  actionItemType: ActionItemType
): PolicyStatement | undefined {
  return policyStatements.find(
    (policyStatement) =>
      actionItemType.action === policyStatement.action && actionItemType.itemType === policyStatement.itemType
  );
}
